<template>

	<div class="login-body">
		<Toast/>
		<div class="login-panel"></div>

		<div class="login-content">

			<div class="grid">
				<!-- <div class="col-12 flex justify-content-end">
					<div class="justify-content-end">
						<router-link :to="{ name: 'login.adm'}">
							<span class=" text-green-500 m-6" style="font-size: 1rem; color: black; text-decoration: underline">Acesso Restrito</span>
						</router-link>
					</div>
				</div> -->

				<div class="col-4 md:col-2">
					<img style="width: 100px; margin: 30px" src="assets/layout/images/logo_tribunal.png" alt="TCE-AM"/>
				</div>
				<div class="col-6 flex justify-content-start" style="margin: 1rem;">
					<h1><span style="font-size: 1rem; color: black">TRIBUNAL DE CONTAS DO</span>
					<br><span style="font-size: 1rem; color: black">ESTADO DO AMAZONAS</span></h1>
				</div>
			</div>

			<h1>Sistema de Processos Seletivos</h1>
			<p>Bem-vindo, por favor efetue o seu login para continuar.</p>

 			<ValidationObserver v-slot="{ handleSubmit }">
    		<form @submit.prevent="handleSubmit(efetuarLogin)">
				<div class="field">
					<transition-group name="p-messages" tag="div" class="col-12 md:col-4">
						<Message v-for="msg	of messages" :severity="msg.severity" :key="msg.content">{{msg.content}}</Message>
					</transition-group>

					<div v-show="confirmacaoEmail">
						<Button label="Reenviar E-mail de Confirmação" class="p-button-text" @click="reenviarEmail()"/>
					</div>

					<ValidationProvider name="E-mail" rules="required|email" v-slot="{ errors }" mode="lazy">
						<span class="p-input-icon-left">
						<i class="pi pi-envelope" />
						<InputText
							id="email"
							placeholder="E-mail"
							v-model="usuario.email"
							:class="{ 'field-invalid': errors[0] }"
							style="width: 300px"/>
						</span>
						<InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
					</ValidationProvider>
				</div>

				<div class="field">
					<ValidationProvider name="Senha" rules="required" v-slot="{ errors }" mode="lazy">
						<span class="p-input-icon-left">
						<i class="pi pi-lock" />
						<InputText id="senha" v-model="usuario.senha" type="password" placeholder="Senha ..."
						:class="{ 'field-invalid': errors[0] }" style="width: 300px"/>
						</span>
						<InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
					</ValidationProvider>
				</div>
				<vue-recaptcha ref="recaptcha" sitekey="6LcajvUpAAAAAHba3Xr9Ov6ob_2TUgw6W3NgEHQZ"  @verify="onVerify"/>
				<Button label="Login" icon="pi pi-check" type="submit" :disabled="verificaRecaptcha"/>
			</form>
		</ValidationObserver>
		<br>
		<div class="grid p-jc-between col-4" style="width: 400px">
			<div class="col-6">
				<router-link :to="{ name: 'novo.usuario'}">
					Cadastre-se
				</router-link>
			</div>
			<div class="col-6">
				<router-link :to="{ name: 'esqueci.senha'}">
					Esqueci a senha
				</router-link>
			</div>
		</div>

		</div>
	</div>
</template>

<script>

	import { validacaoFormulario } from '@/validacaoFormulario'
	import { tratamentoDeErros } from '@/tratamentoDeErros'
	import AuthService from '../service/AuthService'
	import { VueRecaptcha } from 'vue-recaptcha';

	export default {

		mixins: [validacaoFormulario, tratamentoDeErros],
		components: { VueRecaptcha },

		data() {
			return {
				messages: [],
				usuario: {
					email: '',
					senha: ''
				},
				confirmacaoEmail: false,
				authService: null,
				recaptchaToken: '',
				verificaRecaptcha: true
			};
		},

		created() {
			this.authService = new AuthService();
		},
		
		methods: {
			onVerify(token) {
				this.recaptchaToken = token;
				if(this.recaptchaToken){
					this.verificaRecaptcha = false;
				}
			},
			efetuarLogin(){
				if (!this.recaptchaToken) {
					alert('Please complete the reCAPTCHA');
				return;
				}
				this.$store.dispatch('efetuarLogin', this.usuario)
					.then( ()  => {
						console.log('this.$store.state.perfil: ', this.$store.state.perfil);
						this.$router.push( { name: 'home' });
					} )
					.catch(erro =>  {
						console.table(erro);
						this.messages = this.getMessagesError(erro);
						// verificando confirmação de email
						console.table(this.messages);
						this.messages.forEach( msg => {
							this.confirmacaoEmail = msg.content.includes("não confirmado");
						});
					})
			},
			reenviarEmail(){
				console.log("Reenviando e-mail");
				this.$store.state.token = null;
				this.authService.enviarEmailConfirmacao(this.usuario.email)
					.then( () => {
						this.$toast.add({severity:'success', summary: 'Successo', detail: 'E-mail reenviado para ' + this.usuario.email, life: 3000});
					})
					.catch( erro => {
						console.log(erro);
					});
			}
		}
}

</script>


<style scoped>

</style>